import { Fragment, ReactElement } from 'react';
import RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusShared from 'shell/components/shared/ansc-notifications/research-civil-union-non-resident/detail';
import { IdAmbito } from 'shell/constants/id-ambito';
import { CivilUnionDetailAnscNotificationsNonResidentMutationCrumbs } from 'mutation/constants/ansc-notifications.crumbs';

const RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusPage = (): ReactElement => {
  return (
    <Fragment>
      <RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusShared
        items={CivilUnionDetailAnscNotificationsNonResidentMutationCrumbs()}
        scope={IdAmbito.Mutazioni}
      />
    </Fragment>
  );
};

RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusPage.displayName =
  'Research CivilUnion Detail Notifications Page component';

export default RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusPage;
